"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
import Userback from "@userback/widget";
interface UserbackWidgetProps {
  token: string;
}
export function UserbackWidget(t0) {
  const $ = _c(3);
  const {
    token
  } = t0;
  let t1;
  let t2;
  if ($[0] !== token) {
    t1 = () => {
      if (!token) {
        return;
      }
      let cancelled = false;
      Userback(token).then(instance => {
        if (cancelled) {
          instance?.destroy?.();
        }
      }).catch(_temp);
      return () => {
        cancelled = true;
      };
    };
    t2 = [token];
    $[0] = token;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return null;
}
function _temp(error) {
  console.warn("Userback widget failed to initialise", error);
}